import axios from 'axios';
import firebase from 'firebase';

const signIn = ({ email, password }) => firebase.auth().signInWithEmailAndPassword(email, password);
const getDocument = ({ url }) =>
  axios.get(url, { responseType: 'arraybuffer' }).then((response) => {
    const contentType = response.headers['content-type'] || response.headers['Content-Type'] || '';
    return new Blob([response.data], { type: contentType });
  });
const signUp = ({ email, password }) => firebase.auth()
  .createUserWithEmailAndPassword(email, password);
const claimInvite = ({ token }) => axios.post(`invitation/user/${token}`, {});
const getTokenWithRefreshToken = refreshToken => axios.post(`https://securetoken.googleapis.com/v1/token?key=${process.env.REACT_APP_FIREBASE_KEY}&refresh_token=${refreshToken}&grant_type=refresh_token`, {}, {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

export default {
  signIn,
  getDocument,
  signUp,
  claimInvite,
  getTokenWithRefreshToken,
};



// WEBPACK FOOTER //
// ./src/api/application.js